<template>
    <sub-staff-top>
        <v-row>
            <v-col cols="12" md="4" class="mb-50 mb-md-0">
                <v-img :src="image" alt="" />
            </v-col>
            <v-col cols="12" md="8" lg="7" offset-lg="1">
                <div class="w-100 d-sm-flex align-end justify-space-between mb-30 mb-md-70 mb-lg-110">
                    <div>
                        <p class="color-point page-text line-height-1 mb-6 mb-lg-20">{{ position }}</p>
                        <div class="d-flex align-center">
                            <h3 class="tit font-weight-bold line-height-1 mr-8 mr-lg-20">{{ name }}</h3>
                            <v-btn v-if="instagram" large icon class="insta" :href="instagram" target="_blank">
                                <i class="icon icon-insta" />
                            </v-btn>
                        </div>
                    </div>
                    <v-btn to="/inquiry" large color="primary" class="min-w-180px min-w-lg-240px mt-20 mt-sm-0">
                        <span class="d-flex justify-space-between align-center w-100">
                            문의하기
                            <i class="icon icon-right-arrow"></i>
                        </span>
                    </v-btn>
                </div>
                <div v-for="(item, index) in items" :key="index" class="mb-6 mb-lg-10">
                    <v-row class="row--small">
                        <v-col cols="12" md="3">
                            <p class="page-text--lg font-weight-bold">{{ item.subject }}</p>
                        </v-col>
                        <v-col cols="12" md="9" class="mt-n10 mt-md-0">
                            <div class="ml-lg-4">
                                <p v-for="(text, index) in item.content" :key="index" class="page-text dot-text color-grey" :class="{ 'mt-2 mt-lg-8': index !== 0 }">· {{ text }}</p>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
    </sub-staff-top>
</template>

<script>
import SubStaffTop from "../sub/sub-staff-top.vue";

export default {
    components: {
        SubStaffTop,
    },
    props: {
        position: { type: String },
        name: { type: String },
        instagram: { type: String },
        items: { type: Array },
        image: { type: String },
    },
};
</script>